import Button from 'apollo-react/components/Button';
import FileDocuments from 'apollo-react-icons/FileDocuments';
import qs from 'query-string';
import React from 'react';
import { Link } from 'react-router-dom';

import { DOCUMENT_COMPARE } from '../../../constants/Urls';
import { useFormSelector } from '../../../custom-hooks';
import { useTranslation } from '../../../custom-hooks/useTranslation';
import { getUITA } from '../../../utils/commonUtils';
import { getWorkflowInfoProp } from '../../selectors/runtime.selectors';
import { getBuildNumbers } from '../../utils/controls/ssGrid.utils';

const CompareBuildsButton = ({ selectedBuilds, showAddButton }) => {
  const translateString = useTranslation();
  const itmId = useFormSelector(getWorkflowInfoProp, { prop: 'itmId' });

  const { buildNumberA, buildNumberB } = getBuildNumbers(selectedBuilds);

  return (
    <span ui-ta={getUITA('FormCtrl', 'CompareBuildsButton')}>
      <Button
        component={Link}
        style={{ marginRight: showAddButton ? 10 : 0 }}
        color="primary"
        variant="outlined"
        disabled={selectedBuilds.length !== 2}
        target="_blank"
        to={{
          pathname: DOCUMENT_COMPARE,
          search: qs.stringify({
            docId: itmId,
            buildNumberA,
            buildNumberB,
            isForDownload: false,
            preview: false,
          }),
        }}
      >
        <FileDocuments />
        {translateString('Compare Builds')}
      </Button>
    </span>
  );
};

export default CompareBuildsButton;
